import React from "react";

import css from "./DemoLayout.module.css";
import { useResourcesState } from "@/state/resourcesState";
import { Toolbar } from "./Toolbar";
import { useDemoState } from "@/state/demoState";
import { OrderDetails } from "./OrderDetails/OrderDetails";
import { LoadingIndicator } from "./LoadingIndicator/LoadingIndicator";
import { useDebugState } from "@/state/debugState";
import { DebugToolbar } from "./Debug/DebugToolbar";
import { UploadFurnitureXlsxButtonPanel } from "./UploadFurnitureXlsxButtonPanel";

type DemoLayoutProps = {
    canvas: React.ReactNode;
    right: React.ReactNode;
};

export const DemoLayout: React.FC<DemoLayoutProps> = ({ canvas, right }) => {
    const { isLoaded } = useResourcesState();
    const isOrderDetailsOpen = useDemoState((state) => state.isOrderDetailsOpen);
    const setIsOrderDetailsOpen = useDemoState((state) => state.setIsOrderDetailsOpen);
    const isDebugEnabled = useDebugState((state) => state.isDebugEnabled);

    return (
        <div className={css.root}>
            {!isLoaded && <LoadingIndicator />}
            <div className={css.canvasContainer}>{canvas}</div>
            <div className={css.uiContainer}>
                {right}
                <div id="VisibleCanvasArea" className={css.visibleCanvasArea} />
            </div>
            <Toolbar />
            <UploadFurnitureXlsxButtonPanel />
            {isOrderDetailsOpen && <OrderDetails onClose={() => setIsOrderDetailsOpen(false)} />}
            {isDebugEnabled && <DebugToolbar />}
        </div>
    );
};
